// extracted by mini-css-extract-plugin
export var alt = "ParagraphPageTeaser-module--alt--fd0ce";
export var desktopOnly = "ParagraphPageTeaser-module--desktopOnly--ab9ea";
export var main = "ParagraphPageTeaser-module--main--aecbd";
export var mobileOnly = "ParagraphPageTeaser-module--mobileOnly--cbc0b";
export var teaserContainer = "ParagraphPageTeaser-module--teaserContainer--4b61c";
export var textLeft = "ParagraphPageTeaser-module--textLeft--68979";
export var visuallyHidden = "ParagraphPageTeaser-module--visuallyHidden--58791";